import React from 'react';
import { IconProps } from '../../DefaultIcon';

export function CAEIcon({ className }: IconProps) {
  return (
    <svg
      width="76"
      height="76"
      viewBox="0 0 76 76"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1147_1706)">
        <path
          d="M67.1835 76V3.44469C67.1835 1.54168 65.6418 0 63.7388 0H3.44469C1.54168 0 0 1.54168 0 3.44469V66.7499C0 71.8567 4.14326 75.9759 9.22599 75.9759H67.1594L67.1835 76Z"
          fill="#EAEDF8"
        />
        <path
          d="M72.5549 48.274H47.6713C45.7682 48.274 44.2266 46.7323 44.2266 44.8293V10.286C44.2266 8.38299 45.7682 6.84131 47.6713 6.84131H72.5549C74.4579 6.84131 75.9996 8.38299 75.9996 10.286V44.8293C75.9996 46.7323 74.4579 48.274 72.5549 48.274Z"
          fill="#D6DBE7"
        />
        <path
          d="M71.6877 16.8381H48.5384C48.153 16.8381 47.8398 16.525 47.8398 16.1395V11.2977C47.8398 10.9123 48.153 10.5991 48.5384 10.5991H71.6877C72.0731 10.5991 72.3863 10.9123 72.3863 11.2977V16.1395C72.3863 16.525 72.0731 16.8381 71.6877 16.8381Z"
          fill="#B0B9CF"
        />
        <path
          d="M61.6917 31.5321H65.0401C65.4255 31.5321 65.7387 31.219 65.7387 30.8335V27.4852C65.7387 27.0998 65.4255 26.7866 65.0401 26.7866H61.6917C61.3063 26.7866 60.9932 27.0998 60.9932 27.4852V30.8335C60.9932 31.219 61.3063 31.5321 61.6917 31.5321Z"
          fill="white"
        />
        <path
          d="M52.0557 26.7866H48.7074C48.3219 26.7866 48.0088 27.0998 48.0088 27.4852V30.8335C48.0088 31.219 48.3219 31.5321 48.7074 31.5321H52.0557C52.4411 31.5321 52.7543 31.219 52.7543 30.8335V27.4852C52.7543 27.0998 52.4411 26.7866 52.0557 26.7866Z"
          fill="white"
        />
        <path
          d="M59.2582 24.3538V21.0055C59.2582 20.62 58.945 20.3069 58.5596 20.3069H55.2113C54.8259 20.3069 54.5127 20.62 54.5127 21.0055V24.3538C54.5127 24.7392 54.8259 25.0524 55.2113 25.0524H58.5596C58.945 25.0524 59.2582 24.7392 59.2582 24.3538Z"
          fill="white"
        />
        <path
          d="M52.0557 20.3069H48.7074C48.3219 20.3069 48.0088 20.62 48.0088 21.0055V24.3538C48.0088 24.7392 48.3219 25.0524 48.7074 25.0524H52.0557C52.4411 25.0524 52.7543 24.7392 52.7543 24.3538V21.0055C52.7543 20.62 52.4411 20.3069 52.0557 20.3069Z"
          fill="white"
        />
        <path
          d="M58.5352 26.7866H55.1869C54.8014 26.7866 54.4883 27.0998 54.4883 27.4852V30.8335C54.4883 31.219 54.8014 31.5321 55.1869 31.5321H58.5352C58.9206 31.5321 59.2338 31.219 59.2338 30.8335V27.4852C59.2338 27.0998 58.9206 26.7866 58.5352 26.7866Z"
          fill="white"
        />
        <path
          d="M61.6917 38.0121H65.0401C65.4255 38.0121 65.7387 37.6989 65.7387 37.3135V33.9652C65.7387 33.5798 65.4255 33.2666 65.0401 33.2666H61.6917C61.3063 33.2666 60.9932 33.5798 60.9932 33.9652V37.3135C60.9932 37.6989 61.3063 38.0121 61.6917 38.0121Z"
          fill="white"
        />
        <path
          d="M54.5127 33.9652V37.3135C54.5127 37.6989 54.8259 38.0121 55.2113 38.0121H58.5596C58.945 38.0121 59.2582 37.6989 59.2582 37.3135V33.9652C59.2582 33.5798 58.945 33.2666 58.5596 33.2666H55.2113C54.8259 33.2666 54.5127 33.5798 54.5127 33.9652Z"
          fill="white"
        />
        <path
          d="M65.7387 24.3538V21.0055C65.7387 20.62 65.4255 20.3069 65.0401 20.3069H61.6917C61.3063 20.3069 60.9932 20.62 60.9932 21.0055V24.3538C60.9932 24.7392 61.3063 25.0524 61.6917 25.0524H65.0401C65.4255 25.0524 65.7387 24.7392 65.7387 24.3538Z"
          fill="white"
        />
        <path
          d="M67.4727 43.7693C67.4727 44.1788 67.7858 44.492 68.1712 44.492H71.5196C71.905 44.492 72.2181 44.1788 72.2181 43.7693V33.9893C72.2181 33.5798 71.905 33.2666 71.5196 33.2666H68.1712C67.7858 33.2666 67.4727 33.5798 67.4727 33.9893V43.7693Z"
          fill="#00C4B3"
        />
        <path
          d="M68.1712 31.5321H71.5196C71.905 31.5321 72.2181 31.219 72.2181 30.8335V27.4852C72.2181 27.0998 71.905 26.7866 71.5196 26.7866H68.1712C67.7858 26.7866 67.4727 27.0998 67.4727 27.4852V30.8335C67.4727 31.219 67.7858 31.5321 68.1712 31.5321Z"
          fill="white"
        />
        <path
          d="M71.4952 20.3069H68.1468C67.7614 20.3069 67.4482 20.62 67.4482 21.0055V24.3538C67.4482 24.7392 67.7614 25.0524 68.1468 25.0524H71.4952C71.8806 25.0524 72.1937 24.7392 72.1937 24.3538V21.0055C72.1937 20.62 71.8806 20.3069 71.4952 20.3069Z"
          fill="white"
        />
        <path
          d="M48.0332 40.4449V43.7932C48.0332 44.1787 48.3464 44.4918 48.7318 44.4918H52.0801C52.4655 44.4918 52.7787 44.1787 52.7787 43.7932V40.4449C52.7787 40.0595 52.4655 39.7463 52.0801 39.7463H48.7318C48.3464 39.7463 48.0332 40.0595 48.0332 40.4449Z"
          fill="white"
        />
        <path
          d="M52.0557 33.2666H48.7074C48.3219 33.2666 48.0088 33.5798 48.0088 33.9652V37.3135C48.0088 37.6989 48.3219 38.0121 48.7074 38.0121H52.0557C52.4411 38.0121 52.7543 37.6989 52.7543 37.3135V33.9652C52.7543 33.5798 52.4411 33.2666 52.0557 33.2666Z"
          fill="white"
        />
        <path
          d="M54.5127 40.4449V43.7932C54.5127 44.1787 54.8259 44.4918 55.2113 44.4918H58.5596C58.945 44.4918 59.2582 44.1787 59.2582 43.7932V40.4449C59.2582 40.0595 58.945 39.7463 58.5596 39.7463H55.2113C54.8259 39.7463 54.5127 40.0595 54.5127 40.4449Z"
          fill="white"
        />
        <path
          d="M60.9932 40.4449V43.7932C60.9932 44.1787 61.3063 44.4918 61.6917 44.4918H65.0401C65.4255 44.4918 65.7387 44.1787 65.7387 43.7932V40.4449C65.7387 40.0595 65.4255 39.7463 65.0401 39.7463H61.6917C61.3063 39.7463 60.9932 40.0595 60.9932 40.4449Z"
          fill="white"
        />
        <path
          d="M10.0209 25.2209H6.91342C6.528 25.2209 6.21484 25.5341 6.21484 25.9195V33.4352C6.21484 33.8206 6.528 34.1338 6.91342 34.1338H10.0209C10.4063 34.1338 10.7194 33.8206 10.7194 33.4352V25.9195C10.7194 25.5341 10.4063 25.2209 10.0209 25.2209Z"
          fill="#00416B"
        />
        <path
          d="M16.5726 19.7288H13.4652C13.0798 19.7288 12.7666 20.0419 12.7666 20.4273V33.4353C12.7666 33.8207 13.0798 34.1338 13.4652 34.1338H16.5726C16.958 34.1338 17.2712 33.8207 17.2712 33.4353V20.4273C17.2712 20.0419 16.958 19.7288 16.5726 19.7288Z"
          fill="#00416B"
        />
        <path
          d="M23.1498 11.1291H20.0423C19.6569 11.1291 19.3438 11.4422 19.3438 11.8276V33.4593C19.3438 33.8448 19.6569 34.1579 20.0423 34.1579H23.1498C23.5352 34.1579 23.8483 33.8448 23.8483 33.4593V11.8036C23.8483 11.4181 23.5352 11.105 23.1498 11.105"
          fill="#00416B"
        />
        <path
          d="M29.7015 14.887H26.5941C26.2087 14.887 25.8955 15.2001 25.8955 15.5855V33.4353C25.8955 33.8207 26.2087 34.1339 26.5941 34.1339H29.7015C30.087 34.1339 30.4001 33.8207 30.4001 33.4353V15.5855C30.4001 15.2001 30.087 14.887 29.7015 14.887Z"
          fill="#00416B"
        />
        <path
          d="M36.2777 7.1062H33.1703C32.7848 7.1062 32.4717 7.41935 32.4717 7.80477V33.4352C32.4717 33.8206 32.7848 34.1338 33.1703 34.1338H36.2777C36.6631 34.1338 36.9763 33.8206 36.9763 33.4352V7.80477C36.9763 7.41935 36.6631 7.1062 36.2777 7.1062Z"
          fill="#00416B"
        />
        <path
          d="M39.5535 41.3844H29.653C29.0749 41.3844 28.6172 40.9267 28.6172 40.3486C28.6172 39.7704 29.0749 39.3127 29.653 39.3127H39.5535C40.1316 39.3127 40.5893 39.7704 40.5893 40.3486C40.5893 40.9267 40.1316 41.3844 39.5535 41.3844Z"
          fill="#00416B"
        />
        <path
          d="M39.5535 48.2738H29.653C29.0749 48.2738 28.6172 47.8161 28.6172 47.238C28.6172 46.6598 29.0749 46.2021 29.653 46.2021H39.5535C40.1316 46.2021 40.5893 46.6598 40.5893 47.238C40.5893 47.8161 40.1316 48.2738 39.5535 48.2738Z"
          fill="#00416B"
        />
        <path
          d="M59.4267 55.1874H29.653C29.0749 55.1874 28.6172 54.7297 28.6172 54.1515C28.6172 53.5734 29.0749 53.1157 29.653 53.1157H59.4267C60.0048 53.1157 60.4625 53.5734 60.4625 54.1515C60.4625 54.7297 60.0048 55.1874 59.4267 55.1874Z"
          fill="#00416B"
        />
        <path
          d="M50.1043 62.1007H29.653C29.0749 62.1007 28.6172 61.643 28.6172 61.0649C28.6172 60.4867 29.0749 60.0291 29.653 60.0291H50.1043C50.6825 60.0291 51.1402 60.4867 51.1402 61.0649C51.1402 61.643 50.6825 62.1007 50.1043 62.1007Z"
          fill="#00416B"
        />
        <path
          d="M9.34668 76.0001C13.8031 76.0001 17.5128 72.6758 18.0909 68.388C18.1873 67.6895 18.7654 67.1836 19.464 67.1836H74.4827C75.3499 67.1836 76.0003 67.9544 75.8557 68.7975C75.0849 72.8926 71.4957 76.0001 67.1838 76.0001H9.34668Z"
          fill="#00C4B3"
        />
        <path
          d="M21.5831 54.0551L24.787 55.6691C23.2694 58.3188 20.4992 60.0291 17.0545 60.0291C12.7426 60.0291 9.53877 57.3794 8.38251 53.5734H5.25098L6.84083 50.9959H7.99709C7.97301 50.8031 7.97301 50.6586 7.97301 50.49V50.0564H5.27507L6.86492 47.4548H8.4066C9.51469 43.6247 12.7426 40.9268 17.0786 40.9268C20.5232 40.9268 23.2934 42.6371 24.811 45.2868L21.6072 46.9249C20.6919 45.4314 19.1502 44.4919 17.0786 44.4919C14.766 44.4919 13.1039 45.6722 12.2367 47.4548H21.1014L19.5356 50.0564H11.6345V50.49C11.6345 50.6586 11.6345 50.8272 11.6586 50.9959H19.3188L17.8976 53.5734H12.309C13.1521 55.3318 14.8142 56.464 17.1026 56.464C19.1743 56.464 20.716 55.5245 21.6313 54.0551H21.5831Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1147_1706">
          <rect width="76" height="76" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
